import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import LoginHeader from "../../login/LoginHeader";
import LoginCoverImage from "../../login/LoginCoverImage";
import { waitlistInvite } from "store/actions/tiers";
import Loader from "components/pages/components/loader";
import { success as toastSuccess, warn as toastWarn } from '../../../toast';

const InviteBackup = (props) => {
  const {
    triggerWaitlistInvite
  } = props;

  const [isLoading, setIsLoading] = useState(false);
  useEffect(() => {
    setIsLoading(true);
    const params = new URLSearchParams(window.location.search);
    const token = params.get("token");

    if (!token) return toastWarn('Invalid link');

    const payload = {
      token,
      onSuccess: () => {
        setIsLoading(false);
        toastSuccess('Invitation confirmed');
      },
      onError: () => {
        setIsLoading(false);
        toastWarn('Error while trying to confirm invite');
      }
    }

    triggerWaitlistInvite(payload);
  }, []);

  return (
    <>
      {isLoading && <Loader />}
      <div className="flex min-h-screen bg-gray-50">
        <div className="flex flex-col w-full sm:w-3/4">
          <LoginHeader />

          <div className="flex items-center justify-center px-4 mt-16">
            <div className="bg-white rounded-2xl shadow-[0_10px_25px_rgba(0,0,0,0.08),0_-2px_8px_rgba(0,0,0,0.04)] p-10 max-w-lg w-full text-center">
              <h2 className="text-2xl font-semibold text-gray-900 mb-4">
                You have been confirmed for the backup position.
              </h2>

              <p className="text-gray-600 leading-relaxed">
                We will share additional details once everything is finalized by the client.
                In the meantime, please save the date and time.
                We appreciate your flexibility and look forward to working with you.
              </p>
            </div>
          </div>
        </div>

        <LoginCoverImage />
      </div>
    </>
  );
};

const mapDispatchToProps = {
  triggerWaitlistInvite: waitlistInvite 
};

export default connect(null, mapDispatchToProps)(InviteBackup);
